module.exports = __webpack_public_path__ + "img/top BT (1).4ba182d5.png";